export default __webpack_public_path__ + "static/media/DoingWellWithEdit.4a355de2.png";